// extracted by mini-css-extract-plugin
export default {"slider":"ImageSlider_slider__uk6Ru","slideTrack":"ImageSlider_slideTrack__DgozO","scroll":"ImageSlider_scroll__iU4SP","slide":"ImageSlider_slide__8H8-a"};